import type { I18N } from '@vista-digital/i18n'
import type { CensorRating, Film, Genre } from '@vista-digital/ocapi-types/v1'
import { getCensorRatingById, getGenresByIds } from '@vista-digital/occ-domain'
import { EcommerceItem } from '../models-gtm'

export const mapFilmData = (film: Film, i18n: I18N): EcommerceItem => {
    const censorRating: CensorRating | undefined = film.censorRatingId
        ? getCensorRatingById(film.censorRatingId)
        : undefined

    return new EcommerceItem({
        item_id: film.id,
        item_category: 'Movie',
        item_category2: film.distributorName,
        item_category3: getGenresByIds(film?.genreIds ?? [])
            .map((genre: Genre) => {
                return genre ? i18n.translatable(genre.name) : ''
            })
            .join(', '),
        item_category5:
            censorRating && censorRating.classification ? i18n.translatable(censorRating.classification) : 'na',
        item_name: i18n.translatable(film.title),
    })
}
